// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.cesium-sceneModePicker-wrapper {
  display: inline-block;
  position: relative;
  margin: 0 3px;
}

.cesium-sceneModePicker-visible {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.25s linear;
}

.cesium-sceneModePicker-hidden {
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0s 0.25s,
    opacity 0.25s linear;
}

.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-none {
  display: none;
}

.cesium-sceneModePicker-slide-svg {
  transition: left 2s;
  top: 0;
  left: 0;
}

.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-dropDown-icon {
  box-sizing: border-box;
  padding: 0;
  margin: 3px 0;
}

.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-button3D,
.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-buttonColumbusView,
.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-button2D {
  margin: 0 0 3px 0;
}

.cesium-sceneModePicker-wrapper
  .cesium-sceneModePicker-button3D
  .cesium-sceneModePicker-icon2D {
  left: 100%;
}

.cesium-sceneModePicker-wrapper
  .cesium-sceneModePicker-button3D
  .cesium-sceneModePicker-iconColumbusView {
  left: 200%;
}

.cesium-sceneModePicker-wrapper
  .cesium-sceneModePicker-buttonColumbusView
  .cesium-sceneModePicker-icon3D {
  left: -200%;
}

.cesium-sceneModePicker-wrapper
  .cesium-sceneModePicker-buttonColumbusView
  .cesium-sceneModePicker-icon2D {
  left: -100%;
}

.cesium-sceneModePicker-wrapper
  .cesium-sceneModePicker-button2D
  .cesium-sceneModePicker-icon3D {
  left: -100%;
}

.cesium-sceneModePicker-wrapper
  .cesium-sceneModePicker-button2D
  .cesium-sceneModePicker-iconColumbusView {
  left: 100%;
}

.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-selected {
  border-color: #2e2;
  box-shadow:
    0 0 8px #fff,
    0 0 8px #fff;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/SceneModePicker/SceneModePicker.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV;;wBAEsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB;;gBAEc;AAChB","sourcesContent":["span.cesium-sceneModePicker-wrapper {\n  display: inline-block;\n  position: relative;\n  margin: 0 3px;\n}\n\n.cesium-sceneModePicker-visible {\n  visibility: visible;\n  opacity: 1;\n  transition: opacity 0.25s linear;\n}\n\n.cesium-sceneModePicker-hidden {\n  visibility: hidden;\n  opacity: 0;\n  transition:\n    visibility 0s 0.25s,\n    opacity 0.25s linear;\n}\n\n.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-none {\n  display: none;\n}\n\n.cesium-sceneModePicker-slide-svg {\n  transition: left 2s;\n  top: 0;\n  left: 0;\n}\n\n.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-dropDown-icon {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 3px 0;\n}\n\n.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-button3D,\n.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-buttonColumbusView,\n.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-button2D {\n  margin: 0 0 3px 0;\n}\n\n.cesium-sceneModePicker-wrapper\n  .cesium-sceneModePicker-button3D\n  .cesium-sceneModePicker-icon2D {\n  left: 100%;\n}\n\n.cesium-sceneModePicker-wrapper\n  .cesium-sceneModePicker-button3D\n  .cesium-sceneModePicker-iconColumbusView {\n  left: 200%;\n}\n\n.cesium-sceneModePicker-wrapper\n  .cesium-sceneModePicker-buttonColumbusView\n  .cesium-sceneModePicker-icon3D {\n  left: -200%;\n}\n\n.cesium-sceneModePicker-wrapper\n  .cesium-sceneModePicker-buttonColumbusView\n  .cesium-sceneModePicker-icon2D {\n  left: -100%;\n}\n\n.cesium-sceneModePicker-wrapper\n  .cesium-sceneModePicker-button2D\n  .cesium-sceneModePicker-icon3D {\n  left: -100%;\n}\n\n.cesium-sceneModePicker-wrapper\n  .cesium-sceneModePicker-button2D\n  .cesium-sceneModePicker-iconColumbusView {\n  left: 100%;\n}\n\n.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-selected {\n  border-color: #2e2;\n  box-shadow:\n    0 0 8px #fff,\n    0 0 8px #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
